import React from 'react';
import { Inbox } from 'lucide-react';
import clsx from 'clsx';

import CommonLoader from '../../../components/common-loader/CommonLoader';

import scss from './AssetsState.module.scss';

function AssetsState({ isLoading = false, isEmpty, emptyText, loaderWidth = 24, className, children }) {
  return (
    <div className={clsx(scss.state, isLoading && scss.stateLoading, className)}>
      {isLoading ? <CommonLoader isLoading width={loaderWidth} /> : null}
      {!isLoading && isEmpty ? (
        <p className={scss.empty}>
          <Inbox className={scss.emptyIcon} size={14} strokeWidth={1.75} aria-hidden='true' />
          {emptyText}
        </p>
      ) : null}
      {!isLoading && !isEmpty ? children : null}
    </div>
  );
}

export default AssetsState;
